import { ExamResultQuestionKind } from "@knowfully/ui.common";

export enum ExamQuestionTypeId {
  MultipleChoiceQuestion = "031abea9-60dd-42b2-a588-f9d00e67fbb6",
  MultipleAnswersQuestion = "3f30c861-e648-4ab6-938a-6851ff9e1bc4",
  RatingQuestion = "4227e559-3b14-4e07-b90e-73151f723698",
  TextQuestion = "fe47c977-e1da-44e3-8cbe-4e784bae5a33",
  CategoryHeader = "b6144c6c-45dd-46c7-8e1e-58ab8acf1e6b",
  FileUploadVideo = "f2046695-3936-4b86-bfde-049d168eda41",
  FileUploadImage = "8c9c5ba8-c41c-4043-85ae-f87d0d222d49",
  FileUploadDocument = "1a321202-806e-40d5-a815-3e10aa4adcf8",
}

const manualGradingQuestionTypeIds: string[] = [
  ExamQuestionTypeId.TextQuestion,
  ExamQuestionTypeId.FileUploadVideo,
  ExamQuestionTypeId.FileUploadImage,
  ExamQuestionTypeId.FileUploadDocument,
];

export const isManualGradingQuestion = (questionTypeId?: string): boolean =>
  !!questionTypeId && manualGradingQuestionTypeIds.includes(questionTypeId);

export const examQuestionKind = (
  questionTypeId?: string
): ExamResultQuestionKind => {
  if (questionTypeId === ExamQuestionTypeId.CategoryHeader) {
    return ExamResultQuestionKind.Category;
  }

  if (questionTypeId === ExamQuestionTypeId.MultipleAnswersQuestion) {
    return ExamResultQuestionKind.MultiChoice;
  }

  if (isManualGradingQuestion(questionTypeId)) {
    return ExamResultQuestionKind.Text;
  }

  return ExamResultQuestionKind.SingleChoice;
};
